import { mapperBlockCallToAction, mapperBlockMediaCardGroup } from '../../../core/data-layer/blocks/mappers'
import type { MapperOptions } from '#layers/core/types'

/**
 * Page press and media press kit mapper
 * normalizes data to be used in pages
 */
export default (data: any, options: MapperOptions) => {
  if (!data) {
    return null
  }
  const imageOptionsPhotoGallery = {
    sizes: {
      small: { width: 327, height: 184, aspectRatio: '16/9' },
      medium: { width: 312, height: 176, aspectRatio: '16/9' },
      large: { width: 528, height: 370, aspectRatio: '16/9' }
    },
    resize: true
  }
  const imageOptionsLogoGallery = {
    sizes: {
      small: { width: 272, height: 153, aspectRatio: '16/9' },
      medium: { width: 368, height: 207, aspectRatio: '16/9' },
      large: { width: 736, height: 414, aspectRatio: '16/9' }
    },
    resize: true
  }
  return {
    shortDescription: data.shortDescription || '',
    photoGallery: mapperBlockMediaCardGroup(data.photographyGallery, {
      getUrl: options.getUrl,
      imageOptions: imageOptionsPhotoGallery
    }),
    logoGallery: mapperBlockMediaCardGroup(data.logoGallery, {
      getUrl: options.getUrl,
      imageOptions: imageOptionsLogoGallery
    }),
    callToAction: mapperBlockCallToAction(data.callToAction, options.getUrl)
  }
}
